import { SxProps } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const authFieldSx: SxProps = {
  backgroundColor: 'bgSwitch',
  border: '1px solid #E1E8FF',
  borderRadius: 2,
  ':focus': {
    borderColor: '#2952E3',
    boxShadow: '0 0 0 3px #EEF2FF',
  },
};
